import React, { Component } from 'react'
import "video-react/dist/video-react.css"; 


export default class VideoPlayer extends Component {
  
  render() {
    
    const {src,thumbnail, classNameThumbnail} = this.props;
    
    return (
      <>
      <img className={"d-none d-lg-block " + (classNameThumbnail || "")} alt="thumbnail" src={require(`../../assets/images/video-thumbnails/${thumbnail || 'video-thumbnail-overlay.png'}`)} width="300"  data-featherlight={`<iframe  title="This is a title" src=${ src } width="800" height="550" />`}/>
      <div className="d-block d-lg-none">
        {src !== "" && <iframe title="vi" className="f-width" src={src} allowFullScreen={true}></iframe>}
        {src === "" && <center><strong>No video found</strong></center>}
      </div>
      </>
    )
  }
}
